module.exports = __webpack_public_path__ + "static/img/fo.fcae5b2a.svg";